// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__EWNir","openOverlay":"Overlay_openOverlay__3bS4f"};